module.exports = __webpack_public_path__ + "media/iphone_notification.2371aa24.mp3";